var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "margin-top": "10px",
              "margin-bottom": "10px"
            }
          },
          [
            _c(
              "el-radio-group",
              {
                staticStyle: { "margin-top": "7px" },
                model: {
                  value: _vm.rbgOpen,
                  callback: function($$v) {
                    _vm.rbgOpen = $$v
                  },
                  expression: "rbgOpen"
                }
              },
              [
                _c("el-radio", { attrs: { label: 1 } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EnableOpen")))
                ]),
                _c("el-radio", { attrs: { label: 0 } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DisableOpen")))
                ])
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "20px" },
                attrs: { type: "primary" },
                on: { click: _vm.onSave }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
            ),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "tabs-container",
            staticStyle: { position: "relative" },
            attrs: { disabled: true }
          },
          [
            !_vm.rbgOpen
              ? _c("div", {
                  staticStyle: {
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    "background-color": "rgba(0,0,0,.2)",
                    cursor: "not-allowed",
                    "z-index": "9"
                  }
                })
              : _vm._e(),
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  {
                    key: 1,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_OceanExport"),
                      name: "seaExPort"
                    }
                  },
                  [
                    _c("credit-config", {
                      ref: "seaExPort",
                      attrs: { lob: "SE" }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 2,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_OceanImport"),
                      name: "seaImPort"
                    }
                  },
                  [
                    _c("credit-config", {
                      ref: "seaImPort",
                      attrs: { lob: "SI" }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 3,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_AirExport"),
                      name: "aeExPort"
                    }
                  },
                  [
                    _c("credit-config", {
                      ref: "aeExPort",
                      attrs: { lob: "AE" }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 4,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_AirImport"),
                      name: "aeImPort"
                    }
                  },
                  [
                    _c("credit-config", {
                      ref: "aeImPort",
                      attrs: { lob: "AI" }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_RailwayExport"),
                      name: "reExPort"
                    }
                  },
                  [
                    _c("credit-config", {
                      ref: "reExPort",
                      attrs: { lob: "RE" }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_RailwayImport"),
                      name: "riExPort"
                    }
                  },
                  [
                    _c("credit-config", {
                      ref: "riExPort",
                      attrs: { lob: "RI" }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 5,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_FbaSea"),
                      name: "fbaSea"
                    }
                  },
                  [
                    _c("credit-config", { ref: "fbaSea", attrs: { lob: "SE" } })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 6,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_FbaAir"),
                      name: "fbaAir"
                    }
                  },
                  [
                    _c("credit-config", { ref: "fbaAir", attrs: { lob: "AE" } })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 6,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_IntegratedJob"),
                      name: "integrateJob"
                    }
                  },
                  [
                    _c("credit-config", {
                      ref: "integrateJob",
                      attrs: { lob: "IE" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }